@if(faqData){
<div class="my-8 my-xl-13 mx-xl-0 evisa-bg-white rounded-5 faq-container pb-3">
    @if(faqData?.heading){
    <p class="heading-3 ibm-medium linear-gradient-text p-4 line-7">
        <span>{{ 'FAQ.TITLE' | translate }}</span>
    </p>
    }
    @if(faqData?.sections?.length){
    <div>
        @for (section of faqData.sections; track $index) {
        <table class="w-100">
            <thead>
                <tr>
                    <th colspan="2" class="py-2 px-3">
                        <p class="m-0 p-2 heading-4 ibm-semibold linear-gradient-text">
                            {{ section.title | translate }}
                        </p>
                    </th>
                </tr>
            </thead>
            @if(section?.items?.length){
            <tbody>
                @for (faq of section.items; track $index) {
                <tr class="question-row" (click)="faq.expanded = !faq.expanded; "
                    [ngClass]="{'expanded no-border': faq.expanded}">
                    <td class="p-3 px-4 d-flex justify-content-between c-pointer">
                        <p class="text-1 text-blue-2 ibm-medium my-0 line-7">{{ faq.question | translate }}</p>
                        <div class="me-sm-3">
                            <div class="d-flex justify-content-end align-items-end">
                                <span class="status-icon">
                                    <img class="c-pointer evisa-blue-filter-1" [ngClass]="{opened: faq.expanded}"
                                        src="assets/icons/dropdown-open.svg" />
                                </span>
                            </div>
                        </div>
                    </td>
                </tr>
                @if (faq.expanded) {
                <tr>
                    <td [attr.colspan]="2" class="no-border">
                        <p class="my-0 px-4 py-2 text-2 ibm-medium text-blue-3 line-7"
                            [innerHTML]="faq.answer | translate">
                        </p>
                    </td>
                </tr>
                }
                }
            </tbody>
            }
        </table>
        }
    </div>
    }
</div>

}